<template>
    <div class="w-full">
        <label
            v-if="$slots.default"
            class="block cursor-default mb-8 text-body-sm first-letter:uppercase"
        >
            <slot></slot>
        </label>

        <div class="flex items-center w-full relative">
            <slot name="before"></slot>
            <Tooltip
                :content="value.toString()"
                position="top"
                no-arrow
                custom-position
                :forced-position="parsedPosition"
                wrapper-class="w-full relative"
                class="grow"
            >
                <input
                    ref="rangeSlider"
                    type="range"
                    :value="value"
                    :step="step"
                    :min="min"
                    :max="max"
                    :disabled="disabled"
                    @input="handleInput"
                >
                <template #tooltip v-if="$slots.tooltip">
                    <slot name="tooltip"></slot>
                </template>
            </Tooltip>
            <slot name="after"></slot>
        </div>
    </div>
</template>

<script>
import Tooltip from "../navigation/Tooltip.vue";
import styles from "../../../../../../styles.config.js";

export default {
    components: {Tooltip},
    props: {
        value: {
            required: true,
        },
        step: {
            default: 0.01,
        },
        min: {
            default: 0,
        },
        max: {
            default: 1,
        },
        disabled: Boolean,
    },
    data() {
        return {
            percentage: 0,
        }
    },
    computed: {
        styles() {
            return styles;
        },
        parsedPosition() {
            // 12px is the size of the thumb, so we need to calculate it, so that when percentage is 0, the value is half of 16, and when percentage is 100, the value is -12
            return `calc(${this.percentage}% + ${(50 - this.percentage) * 0.12}px)`
        },
        barColor() {
            return this.disabled ? this.styles.colors.primary['40'] : this.styles.colors.secondary.DEFAULT;
        }
    },
    methods: {
        handleInput (e) {
            const tempSliderValue = e.target.value;
            this.percentage = (tempSliderValue / this.max) * 100;
            this.$emit('input', e.target.value);
        }
    },
    watch: {
        value() { // This one is used so that the bar is colored correctly when the value is changed when the component is loaded in the DOM
            const progress = (this.value / this.max) * 100;
            this.$refs.rangeSlider.style.background = `linear-gradient(to right, ${this.barColor} ${progress}%, ${this.styles.colors.primary["20"]} ${progress}%)`;
        },
        percentage() {
            this.$refs.rangeSlider.style.background = `linear-gradient(to right, ${this.barColor} ${this.percentage}%, ${this.styles.colors.primary["20"]} ${this.percentage}%)`;
        }
    },
    mounted() {
        this.percentage = (this.value / this.max) * 100;
    }
};
</script>

<style scoped>
input[type="range"] {
    -webkit-appearance: none;
    @apply appearance-none w-full cursor-pointer outline-none rounded-32 h-8 bg-primary-20;

    &:focus {
        @apply outline-none;
    }
}

input[type="range"] {
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        @apply appearance-none h-12 w-12 bg-secondary rounded-32 border-none;
    }

    &::-moz-range-thumb {
        @apply appearance-none h-12 w-12 bg-secondary rounded-32 border-none;
    }

    &::-ms-thumb {
        @apply appearance-none h-12 w-12 bg-secondary rounded-32 border-none;
    }
}

input[type="range"]:disabled {
    @apply cursor-not-allowed;

    &::-webkit-slider-thumb {
        @apply bg-primary-40 cursor-not-allowed;
    }

    &::-moz-range-thumb {
        @apply bg-primary-40 cursor-not-allowed;
    }

    &::-ms-thumb {
        @apply bg-primary-40 cursor-not-allowed;
    }
}
</style>
